import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'

const AUTH_COOKIE_CONFERENCE_KEY = 'accu'
const CONFERENCE_COMPANY_NAME_KEY = 'ccmn'
export const AUTHENTICATE_LIFE_TIME_MILLISECONDS = 1000 * 60 * 60

function getRandomValue () {
  return Math.random().toString(36).substr(2, 11)
}
export function setAuthCookieForConference (expireTimeMilliSecond) {
  cookie.setItem(AUTH_COOKIE_CONFERENCE_KEY, getRandomValue(), new Date(new Date().getTime() + expireTimeMilliSecond), constant.URL_COOKIE_DOMAIN, '/')
}
export function removeAuthCookieForConference () {
  cookie.removeItem(AUTH_COOKIE_CONFERENCE_KEY)
}

export function isExpireConferenceAuthentication () {
  return cookie.getItem(AUTH_COOKIE_CONFERENCE_KEY) === null
}

export function setCompanyName (memberName) {
  cookie.setItem(CONFERENCE_COMPANY_NAME_KEY, memberName, new Date(new Date().getTime() + 1000 * 60 * 60 * 3), constant.URL_COOKIE_DOMAIN, '/')
}
export function getCompanyName () {
  return cookie.getItem(CONFERENCE_COMPANY_NAME_KEY) || ''
}

export function removeCompanyName () {
  cookie.removeItem(CONFERENCE_COMPANY_NAME_KEY)
}

window.removeConferenceKey = function () {
  removeAuthCookieForConference()
}
